import React from 'react';
import { RoutePermittedRole } from '@crema/constants/AppEnums';

const ChannelUserManagement = React.lazy(() => import('../../modules/channelUser/ChannelUserManagement'));
const ChannelUserGroupManagement = React.lazy(() => import('../../modules/channelUser/ChannelUserGroupManagement'));
const GroupDetail = React.lazy(() => import('../../modules/channelUser/GroupDetail'));
const BizProfile = React.lazy(() => import('../../modules/channelUser/BizProfile'));

export const channelUserConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: '/channelUsers',
    element: <ChannelUserManagement />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/channelUserGroups',
    element: <ChannelUserGroupManagement />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/channelUserGroups/detail',
    element: <GroupDetail />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/bizProfile',
    element: <BizProfile />,
  },
];
